import { Stadium } from 'evidencna-aplikacia-web-ts-axios';

enum StadiumMaterialuEnum {
  FINALNE_PREDBEZNE_STANOVISKO = 'FINALNE_PREDBEZNE_STANOVISKO',
  MPK = 'MPK',
  PRED_VYHLASENIM_V_ZBIERKE = 'PRED_VYHLASENIM_V_ZBIERKE',
  PREDPRIPRAVNA_FAZA_UKONCENA = 'PREDPRIPRAVNA_FAZA_UKONCENA',
  PRIPRAVA_MATERIALU = 'PRIPRAVA_MATERIALU',
  PRIRADENIE_GESTORA = 'PRIRADENIE_GESTORA',
  PROCES_UKONCENY = 'PROCES_UKONCENY',
  ROKOVANIE_NRSR = 'ROKOVANIE_NRSR',
  ROKOVANIE_POV = 'ROKOVANIE_POV',
  ROKOVANIE_VLADA = 'ROKOVANIE_VLADA',
  SCHVALENIE_GESTORA = 'SCHVALENIE_GESTORA',
  SCHVALOVANIE_MINISTER = 'SCHVALOVANIE_MINISTER',
  SPRACOVANIE_PREDKLADATEL = 'SPRACOVANIE_PREDKLADATEL',
  VYHLASENE_V_ZBIERKE = 'VYHLASENE_V_ZBIERKE',
  VYHODNOTENIE_MPK = 'VYHODNOTENIE_MPK',
  VYHODNOTENIE_MPK_AKTY = 'VYHODNOTENIE_MPK_AKTY',
  VYJADRENIA = 'VYJADRENIA',
  ZAPIS_STANOVISKA = 'ZAPIS_STANOVISKA',
  ZAPIS_PREDBEZNEHO_STANOVISKA = 'ZAPIS_PREDBEZNEHO_STANOVISKA',
  ZAPIS_DOPLNENEHO_PREDBEZNEHO_STANOVISKA = 'ZAPIS_DOPLNENEHO_PREDBEZNEHO_STANOVISKA',
}

interface StadiumMaterialu {
  hodnota: StadiumMaterialuEnum,
  nazov: string,
}

function mapStadium(stadium: Stadium): StadiumMaterialu {
  if (!stadium) {
    throw new Error('Missing stadium.');
  }
  return {
    hodnota: StadiumMaterialuEnum[stadium.hodnota],
    nazov: stadium.nazov,
  };
}

export { StadiumMaterialu, StadiumMaterialuEnum, mapStadium };
